// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__1Mjax","result":"style_result__1wI53","header":"style_header__Q59gZ","button":"style_button__ycvns","test":"style_test__R1GNB"};